import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BusinessAuthService } from '../services/business-auth.service';

/** Pantalla elegir empresa: requiere JWT maestra. */
export const businessMasterChooseGuard: CanActivateFn = () => {
  const auth = inject(BusinessAuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    void router.navigate(['/empresas/iniciar-sesion-maestra']);
    return false;
  }
  if (!auth.isMasterSession()) {
    void router.navigateByUrl('/empresas/panel');
    return false;
  }
  return true;
};
